import api from "./axios";

export interface SignupRequest {
    email: string
    password: string
    nickname: string
}

export interface SignupResponse {
    id: string
    email: string
    nickname: string
}

export interface LoginRequest {
    email: string
    password: string
}

export interface LoginResponse {
    token: {
        idToken: {
            SS: string
        }
        refreshToken: {
            SS: string
            ID: string
            UID: string
        }
    }
    user: {
        id: string
        email: string
        nickname: string
    }
}

export interface UserResponse {
    user: {
        email: string
        imageUrl: string
        name: string
        nickname: string
        uid: string
        website: string
    }
}

export interface LogoutRequest {
    tokenID: string
}

export const signup = (request: SignupRequest) => {
    return api.post<SignupResponse>(
        "/account/signup",
        request,
    );
}

export const login = (request: LoginRequest) => {
    return api.post<LoginResponse>(
        "/account/login",
        request,
    );
}

export const me = () => {
    return api.get<UserResponse>(
        "/account/me",
    );
}

export const logout = (request: LogoutRequest) => {
    return api.post(
        "/account/logout",
        request,
    );
}